const API_KEY = import.meta.env.VITE_GEMINI_API_KEY;

if (!API_KEY) {
    console.warn("Gemini AI: Missing VITE_GEMINI_API_KEY in .env");
} else {
    console.log("Gemini AI: API Key found. Using Direct REST API.");
}

const callGeminiDirect = async (promptText) => {
    if (!API_KEY) return null;

    // Using gemini-flash-latest for reliable free-tier access
    const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent?key=${API_KEY}`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                contents: [{
                    parts: [{ text: promptText }]
                }]
            })
        });

        if (!response.ok) {
            const errorData = await response.text();
            console.error(`Gemini API Error (${response.status}):`, errorData);
            return null;
        }

        const data = await response.json();

        if (data.candidates && data.candidates.length > 0 && data.candidates[0].content) {
            const text = data.candidates[0].content.parts[0].text;
            return text.trim();
        } else {
            console.warn("Gemini AI: Response structure unexpected:", data);
            return null;
        }

    } catch (error) {
        console.error("Gemini AI: Network/Fetch Error:", error);
        return null;
    }
};

export const generateDailyChallengeAI = async () => {
    // Creative, open-ended prompt for daily challenges
    const prompt = "Generate a single, creative, short, and inspiring daily art challenge prompt. It should be open-ended enough for drawing, writing, or photography. It should be weird, fun, and unique. Format: Just the prompt text, no quotes.";
    return await callGeminiDirect(prompt);
};

export const generateMusePromptAI = async (category) => {
    let promptText = "";

    switch (category) {
        case 'all':
            promptText = "Generate a single, unique, creative, and inspiring creative prompt. It can be for any medium (drawing, writing, photography, coding).";
            break;
        case 'coding':
            promptText = "Generate a single, short, and interesting coding challenge. It should be suitable for a Game Jam or a quick script. Examples: 'Create a particle system that reacts to music', 'Build a CLI tool that tells jokes'.";
            break;
        case 'ai_art':
            promptText = "Generate a single, detailed, and evocative AI Image Generation text prompt. It should describe a scene, style, and lighting. Do not include aspect ratios.";
            break;
        default:
            // Standard Art/Writing categories
            promptText = `Generate a single, unique, and creative art prompt for category: '${category}'.`;
            break;
    }

    const finalPrompt = `${promptText} It should be inspiring/challenging. Format: Just the prompt text, no quotes.`;

    return await callGeminiDirect(finalPrompt);
};
